import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { MdHome } from 'react-icons/md'
import { useEffect, useRef, useState } from 'react'
import Link from 'next/link'
import { IoIosArrowDown } from 'react-icons/io'
import menuItems, { IMenuItem } from '../menus'
import { getMenuItems } from './util'

interface IProps {

}


const Component: NextPage<IProps> = ({ }) => {
  const Router = useRouter()
  const refMainMenu = useRef<HTMLDivElement>(null);
  const refSubMenu = useRef<HTMLDivElement>(null);
  const [isActiveMainMenu, setIsActiveMainMenu] = useState<boolean>(false)
  const [isActiveSubMenu, setIsActiveSubMenu] = useState<boolean>(false)
  const [selectedMainItem, setSelectedMainItem] = useState<IMenuItem | undefined>(undefined)
  const [selectedSubItem, setSelectedSubItem] = useState<IMenuItem | undefined>(undefined)
  const [selectedSubItems, setSelectedSubItems] = useState<IMenuItem[] | undefined>(undefined)

  useEffect(() => {
    const result = getMenuItems(Router);
    setIsActiveMainMenu(result.isActiveMainMenu);
    setIsActiveSubMenu(result.isActiveSubMenu);
    setSelectedMainItem(result.selectedMainItem);
    setSelectedSubItem(result.selectedSubItem);
    setSelectedSubItems(result.selectedSubItems);
  }, [Router])

  return (
    <div className={`
      ${selectedMainItem === undefined && 'hidden'}
      flex justify-center w-full border-b border-b-[#EAEAEA] h-[60px] border-t border-t-[#EAEAEA] min-w-[1200px]
    `}>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex items-center justify-start'>
        <Link href="/" passHref>
          <div className='flex items-center justify-center px-5 h-full border-x border-x-[#EAEAEA] cursor-pointer hover:bg-[#F7F7F7]'>
              <MdHome className="text-[#333333] w-[20px] h-[20px]" />
          </div>
        </Link>
        <div
          className={`
            relative flex items-center justify-between h-full px-5 w-[280px] border-x border-x-[#EAEAEA] ml-[-1px] cursor-pointer
            ${isActiveMainMenu && 'bg-gg-green text-white'}
          `}
          onMouseOver={() => {refMainMenu && refMainMenu.current && refMainMenu.current.classList.remove('hidden'); }}
          onMouseLeave={() => {refMainMenu && refMainMenu.current && refMainMenu.current.classList.add('hidden'); }}
        >
          <Link href={selectedMainItem && selectedMainItem.href || '/'}>
            <a>
              {selectedMainItem && selectedMainItem.title || ''}
            </a>
          </Link>
          <div>
            <IoIosArrowDown className={`${isActiveMainMenu ? 'bg-gg-green text-white' : 'text-[#333333]'}`} />
          </div>
          <div ref={refMainMenu} className='absolute top-[58px] left-[-1px] w-[281px] border border-[#EAEAEA] z-10 hidden divide-y divide-[#EAEAEA]'>
            {menuItems.map((item, index) => (
              <div key={`lmenu-${index}`} className='flex items-center justify-between h-[60px] bg-white'>
                <Link href={item.href}>
                  <a className='flex items-center justify-start w-full h-full px-5 text-[#333333] hover:bg-[#F7F7F7]'>
                    {item.title}
                  </a>
                </Link>
              </div>
            ))}
          </div>
        </div>

        {selectedSubItems && selectedSubItems.length > 0 && (
          <div
            className={`
              relative flex items-center justify-between h-full px-5 w-[280px] border-x border-x-[#EAEAEA] ml-[-1px] cursor-pointer
              ${isActiveSubMenu && 'bg-gg-green text-white'}
            `}
            onMouseOver={() => {refSubMenu && refSubMenu.current && refSubMenu.current.classList.remove('hidden'); }}
            onMouseLeave={() => {refSubMenu && refSubMenu.current && refSubMenu.current.classList.add('hidden'); }}
          >
            <Link href={selectedSubItem && selectedSubItem.href || '/'}>
              <a>
                {selectedSubItem && selectedSubItem.title || ''}
              </a>
            </Link>
            <div>
              <IoIosArrowDown className={`${isActiveSubMenu ? 'bg-gg-green text-white' : 'text-[#333333]'}`} />
            </div>
            <div ref={refSubMenu} className='absolute top-[59px] left-[0px] w-[278px] border border-[#EAEAEA] z-10 hidden divide-y divide-[#EAEAEA]'>
              {selectedSubItems && selectedSubItems.map((item, index) => (
                <div key={`subMenu-${index}`} className='flex items-center justify-between h-[60px] bg-white'>
                  <Link href={item.href}>
                    <a className='flex items-center justify-start w-full h-full px-5 text-[#333333] hover:bg-[#F7F7F7]'>
                      {item.title}
                    </a>
                  </Link>
                </div>
              ))}
              </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Component
